/*global _*/
import {Vue} from '~/addiesaas'

export const eventBus = window.VueEventBus || (window.VueEventBus = new Vue())

export default eventBus

